import { Component, Inject, OnInit } from '@angular/core';
import { UcPlannerDetail } from '../../../../../../app/modules/setup-equipment/setup-equipment.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SetupEquipmentService } from '../../../../../../app/modules/setup-equipment/setup-equipment.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-closepmservicepopup',
  templateUrl: './closepmservicepopup.component.html',
  styleUrls: ['./closepmservicepopup.component.scss']
})
export class ClosepmservicepopupComponent implements OnInit {

  SmuPmuData:UcPlannerDetail
  pm1Check:boolean;
  secondPmCompleted:boolean;
  PMFloatin1Check:boolean;
  PMFloatin2Check:boolean;
  constructor(private _notification: NotificationsService, private _planerService: SetupEquipmentService,@Inject(MAT_DIALOG_DATA) private _data: any,  public dialogRef: MatDialogRef<ClosepmservicepopupComponent>) { }

  ngOnInit(): void {
    this.SmuPmuData= this._data.element;
  }

  Closepopup(){
    this.dialogRef.close(true);
  }

  Save(){
    this._planerService.PmDatesAdjust(this.SmuPmuData.InspectionId).subscribe(res => {
        if (res.Status == 1) {
          this._notification.success('Success', 'Pm closed successfully');
        }
      },
      error => {
        this._notification.error('Error saving data', 'Failed to save the record');
      }
    );
  }
}
